import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import React from "react";
import { takeFirst } from "~/features/app/utils";
import { DeepDiveGalleryProvider, type DeepDiveGalleryControl as DeepDiveGalleryControlData } from "~/features/blocks/inventory/deep-dive-gallery/context";
import { Wrap } from "~/features/ui/wrap";
import type { HlsVideoSource } from "~/features/ui/video/use-hls-video";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type DeepDiveGalleryBlockViewProps<TControl = DeepDiveGalleryControlData> = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  children?: React.ReactNode;
  controls?: TControl[] | null;
  hasOverlay?: boolean | null;
  hasTopDivider?: boolean | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
  videoSource?: HlsVideoSource;
};
export function DeepDiveGalleryBlockView<TControl = DeepDiveGalleryControlData>({
  anchor,
  children,
  controls = [],
  hasOverlay = false,
  hasTopDivider = true,
  sectionProps,
  theme = "white",
  videoSource
}: DeepDiveGalleryBlockViewProps<TControl>) {
  return <_StyledSection {...sectionProps} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[{
    "position": "relative"
  }, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderTopColor": "var(--stroke-primary)"
  }]}>
      <_StyledWrap data-theme="light" $_css2={[{
      "borderWidth": "0px",
      "padding": "var(--spacing-md)",
      "@media (min-width: 1024px)": {
        "padding": "var(--spacing-xl)"
      }
    }, theme === "grey" ? {
      "backgroundColor": "var(--bg-secondary)"
    } : {
      "backgroundColor": "var(--bg-primary)"
    }]}>
        <_StyledDiv id="deep-dive-gallery">
          <DeepDiveGalleryProvider controls={(controls ?? []) as DeepDiveGalleryControlData[]} videoSource={videoSource} hasStepsOverlay={Boolean(hasOverlay)}>
            {children}
          </DeepDiveGalleryProvider>
        </_StyledDiv>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-1oo2dsp-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-1oo2dsp-1"
})`${p => p.$_css2}`;
var _StyledDiv = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "deep-dive-gallery___StyledDiv",
  componentId: "sc-1sz2q4z-0"
})({
  "position": "relative",
  "height": "100svh",
  "maxHeight": "67.2rem",
  "@media (min-width: 1024px)": {
    "maxHeight": "89.6rem"
  }
});